module.exports = __webpack_public_path__ + "static/media/jason.2350e71d.jpg";